// extracted by mini-css-extract-plugin
export default {"mCard":"lD-z","image":"mD-z","imageNoBackground":"nD-z","imageHasCategory":"oD-z","fullWidth":"pD-z"};